import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap-button-loader';

const SucursalForm = ({ datoEditar, alGuardar, alCancelar, alEliminar }) => {
    const initialFormData = {
        nombre: '',
        direccion: '',
        longitud: '',
        latitud: '',
        horario: '',
        estatus: 'Activo'
    };
    const [formData, setFormData] = useState({
        nombre: '',
        direccion: '',
        longitud: '',
        latitud: '',
        horario: '',
        estatus: 'Activo'
    });
    const [saving, setSaving] = useState(false);
    const [deleting, setDeleting] = useState(false);

    // Si recibimos datos para editar, los cargamos en el formulario
    useEffect(() => {
        if (datoEditar) {
            setFormData({
                nombre: datoEditar.nombre || '',
                direccion: datoEditar.direccion || '',
                longitud: datoEditar.longitud || '',
                latitud: datoEditar.latitud || '',
                horario: datoEditar.horario || '',
                estatus: datoEditar.estatus || 'Activo'
            });
        } else {
            setFormData(initialFormData);
        }
    }, [datoEditar]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!alGuardar) return;
        try {
            setSaving(true);
            await alGuardar(formData);
        } catch (error) {
            console.log(error);
            window.alert(error?.message || 'No se pudo guardar la sucursal');
        } finally {
            setSaving(false);
        }
    };


    const handleDelete = async () => {
        if (!datoEditar || !alEliminar) return;
        const confirmed = window.confirm('Deseas eliminar esta sucursal?');
        if (!confirmed) return;
        try {
            setDeleting(true);
            await alEliminar(datoEditar);
        } catch (error) {
            console.log(error);
            window.alert(error?.message || 'No se pudo eliminar la sucursal');
        } finally {
            setDeleting(false);
        }
    };

    return (
        <div className="card">
            <div className="card-header">
                <h5>{datoEditar ? 'Editar Sucursal' : 'Nueva Sucursal'}</h5>
            </div>
            <form onSubmit={handleSubmit}>
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-6 mb-3">
                            <label>Nombre de la Sucursal</label>
                            <input type="text" className="form-control" name="nombre" value={formData.nombre} onChange={handleChange} required />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label>Estatus</label>
                            <select className="form-control" name="estatus" value={formData.estatus} onChange={handleChange}>
                                <option value="Activo">Activo</option>
                                <option value="Inactivo">Inactivo</option>
                            </select>
                        </div>
                        <div className="col-md-12 mb-3">
                            <label>Dirección</label>
                            <input type="text" className="form-control" name="direccion" value={formData.direccion} onChange={handleChange} required />
                        </div>
                        <div className="col-md-4 mb-3">
                            <label>Longitud</label>
                            <input type="text" className="form-control" name="longitud" value={formData.longitud} onChange={handleChange} />
                        </div>
                        <div className="col-md-4 mb-3">
                            <label>Latitud</label>
                            <input type="text" className="form-control" name="latitud" value={formData.latitud} onChange={handleChange} />
                        </div>
                        <div className="col-md-4 mb-3">
                            <label>Horario</label>
                            <input type="text" className="form-control" name="horario" value={formData.horario} onChange={handleChange} />
                        </div>
                    </div>
                </div>
                <div className="card-footer text-right">
                    <button type="button" className="btn btn-light mr-2" onClick={alCancelar}>Cancelar</button>
                    {datoEditar && (
                        <Button
                            type="button"
                            className="btn btn-danger mr-2"
                            onClick={handleDelete}
                            loading={deleting}
                        >
                            Eliminar
                        </Button>
                    )}
                    <Button type="submit" className="btn btn-primary" loading={saving}>
                        Guardar Sucursal
                    </Button>
                </div>
            </form>
        </div>
    );
};

export default SucursalForm;